module.exports = __webpack_public_path__ + "img/button-key.79e4057e.svg";